import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var MoveVerticalIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1981 1.25735C11.098 1.12735 10.902 1.12735 10.8019 1.25735L7.84574 5.09751C7.71919 5.2619 7.83638 5.50001 8.04384 5.50001H10V9.00001C10 9.5523 10.4477 10 11 10C11.5523 10 12 9.5523 12 9.00001V5.50001H13.9562C14.1636 5.50001 14.2808 5.26191 14.1543 5.09751L11.1981 1.25735ZM8.00001 12.5L8.00001 9.00001C8.00001 8.44773 7.5523 8.00001 7.00001 8.00001C6.44773 8.00001 6.00001 8.44773 6.00001 9.00001L6.00001 12.5H4.04386C3.8364 12.5 3.71921 12.7381 3.84575 12.9025L6.80191 16.7427C6.90199 16.8727 7.09804 16.8727 7.19811 16.7427L10.1543 12.9025C10.2808 12.7381 10.1636 12.5 9.95617 12.5H8.00001Z"
  }));
});
MoveVerticalIcon.displayName = 'MoveVerticalIcon';
export default MoveVerticalIcon;